import React, { useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import './Tooltip.css';

const Tooltip = ({ text, children }) => {
  const [visible, setVisible] = useState(false);
  const [coords, setCoords] = useState({ top: 0, left: 0 });
  const ref = useRef();

  const showTooltip = () => {
    const rect = ref.current.getBoundingClientRect();
    setCoords({
      top: rect.top + window.scrollY, // 40px arriba del botón
      left: rect.left + window.scrollX + rect.width / 2,
    });
    setVisible(true);
  };

  const hideTooltip = () => setVisible(false);

  return (
    <>
      <span
        ref={ref}
        onMouseEnter={showTooltip}
        onMouseLeave={hideTooltip}
        style={{ display: 'inline-block' }}
      >
        {children}
      </span>
      {visible &&
        ReactDOM.createPortal(
          <div
            className="custom-tooltip-portal"
            style={{
              position: 'absolute',
              top: coords.top,
              left: coords.left,
              transform: 'translate(-50%, -100%)',
              zIndex: 9999,
            }}
          >
            {text}
          </div>,
          document.body
        )}
    </>
  );
};

export default Tooltip;